// Importación dinámica del bootstrap - REQUERIDO para Module Federation con eager: true
import('./bootstrap');